import React, { createContext, useReducer } from "react";
import { useUser, useUserOrders } from "../../Api/userApi";
import FullPageLoader from "../../components/Loaders/FullPageLoader";
import PropTypes from "prop-types";
import { isEqual } from "lodash";

export const ACTIONS = {
    CHANGE_PAGE: "CHANGE_PAGE",
    LOGIN: "LOGIN",
    SET_ORDER: "SET_ORDER",
    UNSET_ORDER: "UNSET_ORDER",
};

export const PAGES = {
    OVERVIEW: "overview",
    ADDRESS: "address",
    PROFILE: "profile",
    PASSWORD: "password",
    ORDERS_OVERVIEW: "ordersOverview",
    ORDER_DETAIL: "orderDetail",
};

const CustomerAreaContext = createContext({});

const CustomerAreaReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case ACTIONS.CHANGE_PAGE:
            return { ...state, page: payload };
        case ACTIONS.LOGIN:
            return { ...state, user: payload };
        case ACTIONS.SET_ORDER:
            window.scrollTo({ top: 0 });
            return {
                ...state,
                selectedOrder: payload,
                page: PAGES.ORDER_DETAIL,
            };
        case ACTIONS.UNSET_ORDER:
            return { ...state, selectedOrder: null, page: PAGES.OVERVIEW };
        default:
            throw new Error(`No action for this ${type}`);
    }
};

const initialState = {
    user: {},
    page: PAGES.OVERVIEW,
    selectedOrder: null,
};

const CustomerAreaProvider = ({ children }) => {
    const [state, dispatch] = useReducer(CustomerAreaReducer, initialState);
    const { isLoading, user } = useUser();
    const { isLoading: ordersLoading } = useUserOrders();

    if (isLoading || ordersLoading) {
        return <FullPageLoader />;
    }

    if (!isEqual(user, state.user)) {
        dispatch({ type: ACTIONS.LOGIN, payload: user });
    }

    return (
        <CustomerAreaContext.Provider value={{ state, dispatch }}>
            {children}
        </CustomerAreaContext.Provider>
    );
};

CustomerAreaProvider.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
};

export { CustomerAreaProvider, CustomerAreaContext };
